export default __webpack_public_path__ + "static/media/dev_tools.61aaef7e.jpg";